import { render, staticRenderFns } from "./ExchangeSchool.vue?vue&type=template&id=3769e576"
import script from "./ExchangeSchool.vue?vue&type=script&lang=js"
export * from "./ExchangeSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports